"use strict";
"use client";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShareRoleSelect = void 0;
var _react = require("react");
var _select = require("@design/ui/select");
var _utils = require("@design/lib/utils");
var _portalLayer = require("@common/components/share/portal-layer");
var _resourceShareCopy = require("./resource-share-copy");
var _shareMenuClasses = require("./share-menu-classes");
var _jsxRuntime = require("react/jsx-runtime");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var GRANT_ROLES_IN_MENU_ORDER = ["editor", "viewer"];
var REMOVE_COLLABORATOR_MENU_VALUE = "remove";
var ShareRoleSelect = exports.ShareRoleSelect = function ShareRoleSelect(_ref) {
  var role = _ref.role,
    resourceKind = _ref.resourceKind,
    disabled = _ref.disabled,
    ariaLabel = _ref.ariaLabel,
    viewerOnly = _ref.viewerOnly,
    onRoleChange = _ref.onRoleChange,
    onRemoveCollaborator = _ref.onRemoveCollaborator;
  var isRemovalChosenRef = (0, _react.useRef)(false);
  var rolesInMenu = viewerOnly ? GRANT_ROLES_IN_MENU_ORDER.filter(function (menuRole) {
    return menuRole === "viewer";
  }) : GRANT_ROLES_IN_MENU_ORDER;
  var roleItems = rolesInMenu.map(function (menuRole) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_select.SelectItem, {
      value: menuRole,
      className: _shareMenuClasses.SHARE_MENU_ITEM_CLASS,
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
        className: "flex flex-col gap-1 whitespace-normal",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: "text-sm text-foreground-primary",
          children: _resourceShareCopy.GRANT_ROLE_LABELS[menuRole]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: _shareMenuClasses.SHARE_MENU_ITEM_DESCRIPTION_CLASS,
          children: (0, _resourceShareCopy.grantRoleDescription)(menuRole, resourceKind)
        })]
      })
    }, menuRole);
  });
  var removeCollaboratorItem = onRemoveCollaborator ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_select.SelectSeparator, {
      className: "my-1 bg-border-default"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_select.SelectItem, {
      value: REMOVE_COLLABORATOR_MENU_VALUE,
      className: (0, _utils.cn)(_shareMenuClasses.SHARE_MENU_ITEM_CLASS, "text-sm text-foreground-primary"),
      children: "Remove collaborator"
    })]
  }) : null;
  function changeSelection(value) {
    if (value === REMOVE_COLLABORATOR_MENU_VALUE) {
      isRemovalChosenRef.current = true;
      return;
    }
    onRoleChange(value);
  }
  function openRemovalOnceMenuHasClosed() {
    if (!isRemovalChosenRef.current) return;
    isRemovalChosenRef.current = false;
    onRemoveCollaborator === null || onRemoveCollaborator === void 0 || onRemoveCollaborator();
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_select.Select, {
    value: role,
    disabled: disabled,
    onValueChange: changeSelection,
    "data-sentry-element": "Select",
    "data-sentry-component": "ShareRoleSelect",
    "data-sentry-source-file": "share-role-select.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_select.SelectTrigger, {
      "aria-label": ariaLabel,
      className: "border-transparent bg-transparent px-3 shadow-none",
      "data-sentry-element": "SelectTrigger",
      "data-sentry-source-file": "share-role-select.tsx",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_select.SelectValue, {
        "data-sentry-element": "SelectValue",
        "data-sentry-source-file": "share-role-select.tsx",
        children: _resourceShareCopy.GRANT_ROLE_LABELS[role]
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_select.SelectContent, _objectSpread(_objectSpread({}, _portalLayer.PORTAL_LAYER_PROPS), {}, {
      position: "popper",
      align: "end",
      className: (0, _utils.cn)("z-floating w-80", _shareMenuClasses.SHARE_MENU_CONTENT_CLASS),
      onCloseAutoFocus: openRemovalOnceMenuHasClosed,
      "data-sentry-element": "SelectContent",
      "data-sentry-source-file": "share-role-select.tsx",
      children: [roleItems, removeCollaboratorItem]
    }))]
  });
};